// Run the animation on all elements with a class of ‘countup’
$(document).ready(function () {

	// Iterate over each .slider container independently
    document.querySelectorAll('.slider').forEach(function (slider) {

        var listPict = slider.querySelectorAll('.slide');

        if (listPict.length === 0) {
            return;
        }

		//This is the latest img, it will serve to know wich img to hide
		var old = listPict.length - 1;
		//This will represent the current img to show
		var current = 0;

		//The timeout will recall this function every 3 sec
		function loop() {
			//We set the class of the current img to show
			listPict[current].classList.add('show');
			listPict[old].classList.add('hide');

			listPict[old].classList.remove('show');
			listPict[current].classList.remove('hide');

			//Update the variables !
			old = current;
			current++;

			//If the current is bigger then the list of images, return to 0
			if (current === listPict.length)
				current = 0;

			//Recall every 6 sec
			setTimeout(loop, 6000);
		}

		loop();
    });
})